/**
 * Side cart (offcanvas minicart) - lihat woocommerce/block-wc-offcanvas-minicart.php.
 *
 * Buka/tutup panelnya sendiri tetap ditangani komponen "ss" parent theme
 * (data-ss-toggle="offcanvas"). Modul ini cuma soal KAPAN panel itu dibuka
 * otomatis, yaitu setiap habis add to cart:
 *
 * - add to cart AJAX (tombol di listing produk): event jQuery `added_to_cart`
 * - add to cart lewat submit form biasa (halaman produk): halamannya reload,
 *   jadi PHP yang menitipkan flag window.dufengOpenMinicart di footer
 *   (lihat dufeng_minicart_flag_open di includes/woocommerce/minicart.php)
 *
 * Plus tombol +/- quantity tiap item, yang memanggil endpoint wc-ajax
 * dufeng_minicart_set_quantity (includes/woocommerce/minicart.php) lalu
 * memasang cart fragments hasilnya.
 */

var PANEL_ID = "site-offcanvas-minicart";
// Kalau cart fragments tidak kunjung selesai (offline, error), panel tetap
// dibuka supaya user tidak merasa tombolnya tidak berfungsi.
var FRAGMENT_WAIT_TIMEOUT = 1500;
// Lama pesan stepper quantity (mis. "Maksimal 3 item") ditampilkan.
var NOTICE_TIMEOUT = 4000;

/**
 * Komponen offcanvas parent theme tidak mengekspor API apapun ke window - satu-
 * satunya pintu masuknya adalah listener click delegated di document untuk
 * [data-ss-toggle="offcanvas"]. Jadi pemicunya dibuat dadakan, diklik, lalu
 * dibuang lagi.
 */
function openMinicart() {
  var panel = document.getElementById(PANEL_ID);
  if (!panel || panel.classList.contains("ss-show")) return;

  var trigger = document.createElement("button");
  trigger.type = "button";
  trigger.hidden = true;
  trigger.setAttribute("data-ss-toggle", "offcanvas");
  trigger.setAttribute("data-ss-target", "#" + PANEL_ID);

  document.body.appendChild(trigger);
  trigger.click();
  trigger.remove();
}

/**
 * Setelah reload, isi panel baru terisi begitu cart fragments di-apply. Buka
 * panelnya setelah fragment siap supaya tidak sempat kelihatan "No products in
 * the cart" lalu berganti isi.
 */
function openAfterFragments($) {
  var opened = false;
  var open = function () {
    if (opened) return;
    opened = true;
    openMinicart();
  };

  if ($) {
    $(document.body).on("wc_fragments_refreshed wc_fragments_loaded", open);
  }

  setTimeout(open, FRAGMENT_WAIT_TIMEOUT);
}

/**
 * Isi panel diganti utuh tiap kali cart fragments di-apply, jadi tidak ada
 * gunanya menyimpan referensi elemen - semua interaksi didelegasikan ke panel.
 */
function getPanel() {
  return document.getElementById(PANEL_ID);
}

function showNotice(message) {
  var panel = getPanel();
  var notice = panel && panel.querySelector(".dufeng-minicart__notice");
  if (!notice) return;

  if (!message) {
    notice.hidden = true;
    notice.textContent = "";
    return;
  }

  notice.textContent = message;
  notice.hidden = false;

  clearTimeout(notice.dufengTimer);
  notice.dufengTimer = setTimeout(function () {
    notice.hidden = true;
    notice.textContent = "";
  }, NOTICE_TIMEOUT);
}

/**
 * Fragments hasil update quantity dipasang lewat event `removed_from_cart`
 * WooCommerce, bukan replace manual: event itulah yang dipakai cart-fragments.js
 * untuk menyimpan cache fragments + cart hash di sessionStorage, dan
 * add-to-cart.js untuk mengganti isi DOM-nya. Kalau di-replace sendiri,
 * cache-nya jadi basi dan panel bisa balik ke isi lama di halaman berikutnya.
 */
function applyFragments($, fragments, cartHash) {
  if (!fragments) return;

  // wc_add_to_cart_params = penanda add-to-cart.js WooCommerce aktif; dialah
  // yang mengganti isi DOM begitu event di bawah di-trigger. Kalau tidak ada,
  // fragments-nya dipasang manual di sini supaya panel tetap ter-update.
  if (!$ || !window.wc_add_to_cart_params) {
    Object.keys(fragments).forEach(function (key) {
      var el = document.querySelector(key);
      if (el) el.outerHTML = fragments[key];
    });
  }

  if ($) {
    $(document.body).trigger("removed_from_cart", [fragments, cartHash]);
  }
}

function setQuantity($, cartItemKey, quantity, row) {
  var params = window.dufeng_minicart_params;
  if (!params || !params.set_quantity_url) return;

  if (row) row.classList.add("is-updating");

  var body = new URLSearchParams();
  body.append("cart_item_key", cartItemKey);
  body.append("quantity", quantity);

  fetch(params.set_quantity_url, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      showNotice(data && data.message ? data.message : "");

      // Fragments juga dikirim saat gagal/di-clamp, jadi tampilan selalu
      // dikembalikan ke kondisi keranjang yang sebenarnya di server. Baris yang
      // dikunci ikut hilang bersama DOM lamanya - kecuali kalau fragments-nya
      // memang tidak ada (mis. request ditolak), makanya dibuka lagi di sini.
      if (data && data.fragments) {
        applyFragments($, data.fragments, data.cart_hash);
      } else if (row) {
        row.classList.remove("is-updating");
      }
    })
    .catch(function () {
      if (row) row.classList.remove("is-updating");
      // Keranjangnya mungkin sudah berubah di server; biar tidak menampilkan
      // angka yang salah, minta WooCommerce refresh fragments-nya.
      if ($) $(document.body).trigger("wc_fragment_refresh");
    });
}

/**
 * Tombol +/- dan input angka di tiap baris item.
 *
 * Semua listener di-pasang di panel (delegated) karena isinya dirender ulang
 * terus lewat cart fragments - bind langsung ke tombolnya akan hilang begitu
 * fragment pertama masuk.
 */
function initQuantityStepper($, panel) {
  function submit(control, quantity) {
    var cartItemKey = control.getAttribute("data-cart-item-key");
    var input = control.querySelector(".dufeng-minicart__qty-input");
    var min = parseInt(input.getAttribute("min"), 10) || 1;
    var max = parseInt(input.getAttribute("max"), 10) || 0;

    if (isNaN(quantity) || quantity < min) quantity = min;
    if (max > 0 && quantity > max) quantity = max;

    if (quantity === parseInt(input.defaultValue, 10)) {
      input.value = quantity;
      return;
    }

    // Feedback langsung; angka finalnya tetap datang dari fragments server.
    input.value = quantity;

    setQuantity($, cartItemKey, quantity, control.closest(".dufeng-minicart__item"));
  }

  panel.addEventListener("click", function (event) {
    var button = event.target.closest(".dufeng-minicart__qty-btn");
    if (!button || button.disabled) return;

    var control = button.closest(".dufeng-minicart__qty");
    var input = control && control.querySelector(".dufeng-minicart__qty-input");
    if (!input) return;

    var step = parseInt(button.getAttribute("data-step"), 10) || 0;
    submit(control, (parseInt(input.value, 10) || 1) + step);
  });

  panel.addEventListener("change", function (event) {
    var input = event.target.closest(".dufeng-minicart__qty-input");
    if (!input) return;

    submit(input.closest(".dufeng-minicart__qty"), parseInt(input.value, 10));
  });

  // Enter di input angka: jangan sampai submit form manapun, cukup lepas fokus
  // supaya event `change` di atas yang jalan.
  panel.addEventListener("keydown", function (event) {
    if ("Enter" !== event.key) return;
    var input = event.target.closest(".dufeng-minicart__qty-input");
    if (!input) return;

    event.preventDefault();
    input.blur();
  });
}

export function initMinicart() {
  var panel = getPanel();
  if (!panel) return;

  // `added_to_cart` di-trigger jQuery (bukan event DOM asli), jadi cuma bisa
  // didengar lewat jQuery-nya WooCommerce.
  var $ = window.jQuery;
  if ($) {
    $(document.body).on("added_to_cart", function () {
      openMinicart();
    });
  }

  initQuantityStepper($, panel);

  if (window.dufengOpenMinicart) {
    openAfterFragments($);
  }
}
